import React, { useState, createContext, useMemo } from 'react';
import { Col, Row } from 'reactstrap';
import lodash from 'lodash';
import { ContainerPageContent } from '../form-builder/build/withPageContentContainerStyle';

export const ModalContext = createContext(null);

const withFilterTableModal = (FilterComponent, TableComponent, ModalComponent, filterStateInterceptor) => {
   const WrappedComponent = (props) => {
      const [filterState, setFilterState] = useState(undefined);
      const [filterStateTABLE, setFilterStateTABLE] = useState(undefined);

      const [changeListenerToOpenForm, setChangeListenerToOpenForm] = useState();

      const [isModalOpen, setIsModalOpen] = useState(false);
      const [modalState, setModalState] = useState({});

      const handleSetFilterState = (newFilterState) => {
         setFilterState(newFilterState);

         if (filterStateInterceptor && lodash.isFunction(filterStateInterceptor)) {
            setFilterStateTABLE(filterStateInterceptor(newFilterState));
         } else {
            setFilterStateTABLE(newFilterState);
         }
      };

      const modalContextValue = useMemo(() => {
         return {
            isOpen: isModalOpen,
            setIsOpen: setIsModalOpen,
            modalState,
            setModalState,
            setFilterState: handleSetFilterState,
            filterState,
         };
      }, [isModalOpen, setIsModalOpen, modalState, setModalState]);

      return (
         <ModalContext.Provider value={ modalContextValue }>
            <ContainerPageContent>
               <div>
                  <h4>
                     { props.pageTitle ? props.pageTitle : '' }
                  </h4>
               </div>
               <div className='position-relative'>
                  { FilterComponent && (
                     <FilterComponent
                        changeListenerToOpenForm={ changeListenerToOpenForm }
                        filterState={ filterState }
                        setFilterState={ handleSetFilterState }
                     />
                  )}
                  {
                     !!props.children && FilterComponent
                  && (
                     <div
                        className='position-absolute container'
                        style={{
                           left: 0,
                           top: 0,
                        }}
                     >
                        <Row>
                           <Col
                              xs='8'
                              sm='6'
                              lg='5'
                           />
                           <Col
                              xs='4'
                              sm='6'
                           >
                              {props.children}
                           </Col>
                        </Row>

                     </div>
                  )
                  }
               </div>
               { TableComponent && (
                  <div className='mt-4'>
                     <TableComponent
                        setChangeListenerToOpenForm={ setChangeListenerToOpenForm }
                        filterState={ filterStateTABLE }
                        pageTitle={ props.pageTitle }
                        tableTitle={ props.tableTitle }
                        filterTableConfig={ props.filterTableConfig }
                     />
                  </div>
               )}
               { ModalComponent && (
                  <ModalComponent
                     isOpen={isModalOpen}
                     filterState={filterState}
                     setFilterState={handleSetFilterState}
                  />
               )}
            </ContainerPageContent>
         </ModalContext.Provider>
      );
   };
   return WrappedComponent;
};

export default withFilterTableModal;
